import React from 'react';

import { Loader, LoaderItem } from '../LazyLoader/styled';
import { StyledContentAreaLoaderWrapper } from './styled';

const ContentAreaLoader = () => {
  return (
    <StyledContentAreaLoaderWrapper>
      <Loader>
        <LoaderItem />
        <LoaderItem />
        <LoaderItem />
      </Loader>
    </StyledContentAreaLoaderWrapper>
  );
};

export default ContentAreaLoader;
